//
import React, { useEffect, useState } from 'react';
import { Dialog, Paragraph, Portal, Title } from 'react-native-paper';
import colors from '../../colors';
import { TXT_M, TXT_P, TXT_PP, MAX_WIDTH_MODAL } from '../../constants';
import { useSessaoOnly } from '../../redux/sessao/sessaoHooks';
import Button from '../Generic/Button';
import { StyleSheet, View, Text, ActivityIndicator, Platform, Linking } from 'react-native';
import clienteApi from '../../apis/clienteApi';
import { celularMask } from '../../shared/helper';
import { Alert } from 'react-native';
import CModal from '../Generic/CModal';
import CTextInput from '../Generic/CTextInput';
import { useEmpresa } from '../../redux/empresa/empresaHooks';

type Props = {
  open: boolean;
  setOpen: (x: boolean) => void;
};

const EsqueciSenhaDialog: React.FC<Props> = (props) => {
  const { open, setOpen } = props;
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState('');

  const [empresa] = useEmpresa();

  const pedirRenovacaoSenha = async () => {
    setLoading(true);
    try {
      console.log('empresa', empresa);

      const texto = `Poderia me ajudar? Esqueci minha senha do aplicativo. Meu email/celular é: ${info}`;
      const url = `https://api.whatsapp.com/send?phone=+55${empresa.telefone}&text=${encodeURI(
        texto
      )}`;

      if (Platform.OS == 'web') {
        window.open(url, '_blank');
      } else {
        Linking.openURL(url);
      }

      setOpen(false);
    } catch (err) {
      console.log('Erro');
      Alert.alert('Erro', err.data ?? 'Erro ao cadastrar comanda.');
    }
    setLoading(false);
  };

  if (loading) {
    return (
      <CModal mostrarModal={open} onClose={() => setOpen(false)} style={{ padding: 20 }}>
        <ActivityIndicator size={50} color={colors.primary} />
      </CModal>
    );
  }

  return (
    <CModal mostrarModal={open} onClose={() => setOpen(false)}>
      <Dialog.Content>
        <Title>Esqueceu sua senha?</Title>
        <Paragraph style={{ marginBottom: 20 }}>
          Informe seu email ou número de celular para recuperá-la:
        </Paragraph>

        <CTextInput
          label={'Celular com DDD ou Email'}
          onChangeText={(txt) => {
            setInfo(txt);
          }}
          value={info}
          style={styles.input}
        />

        <Button title="ENVIAR" onPress={() => pedirRenovacaoSenha()} />
      </Dialog.Content>
      {/* <Dialog.Actions style={{ justifyContent: 'space-around' }}></Dialog.Actions> */}
    </CModal>
  );
};

const styles = StyleSheet.create({
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  }
});

export default EsqueciSenhaDialog;
